/**
 * @desc 导入箱子绑定sku关系
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBox/importSupplierBoxBindSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
